import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ThreeChildView from '../ChildTabView/ThreeChildView'
import StudentActivities from '../StudentActivities/StudentActivities'
import * as studentSignupsDuck from '../../studentSignupsDuck'
import * as studentActivitiesDuck from '../../studentActivitiesDuck'
import sampleStudentData from './sampleStudent.json'
import selectors from '../../../../../store/shared/selectors'

/**
 * @class StudentDetailsView
 * @description Display for an individual student
 */
class StudentDetailsView extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    activeIndex: PropTypes.number.isRequired,
    performRetrieveStudentActivities: PropTypes.func.isRequired,
    selectActiveStudent: PropTypes.func.isRequired,
    students: PropTypes.array.isRequired,
    studentActivities: PropTypes.object.isRequired,
    isLessThanMedium: PropTypes.bool,
  }

  /**
   * @method componentWillMount
   * @description Retrieves student activities
   */
  componentWillMount() {
    this.props.performRetrieveStudentActivities()
  }

  /**
   * @method render
   */
  render() {
    const showSample = !this.props.students.length
    const studentData = this.props.students.length
      ? this.props
      : sampleStudentData
    const {
      activeIndex,
      selectActiveStudent,
      students,
      studentActivities,
      isLessThanMedium,
    } = studentData
    const activeStudent = students[activeIndex]

    return (
      <div>
        {showSample &&
        <div style={{
          position: 'absolute',
          paddingTop: 90,
          width: '100%',
          backgroundColor: '#ffffffcf',
          zIndex: 1,
          height: '100%',
          fontSize: 20,
          textAlign: 'center',
        }}>
          Your student's activities <br/>will display here
        </div>
        }
        <div className="row m-0" style={showSample ? {filter: 'blur(4px)'} : {}}>
          <ThreeChildView
            students={students}
            activeStudentId={activeStudent && activeStudent._id}
            onClick={selectActiveStudent}
          />
          <div className="parent-detail-container">
            <StudentActivities
              student={activeStudent}
              activities={studentActivities}
              isMobile={isLessThanMedium}
            />
          </div>

        </div>
      </div>

    )
  }
}

const mapStateToProps = state => ({
  activeIndex: studentSignupsDuck.getActiveIndex(state),
  studentActivities: studentActivitiesDuck.getStudentActivitiesWithTaskType(
    state,
  ),
  students: studentSignupsDuck.getSignups(state),
  isLessThanMedium: selectors.isLessThanMedium(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selectActiveStudent: studentSignupsDuck.setActiveIndex,
      performRetrieveStudentActivities:
        studentActivitiesDuck.performRetrieveStudentActivities,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(StudentDetailsView)



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/components/StudentDetailsView/StudentDetailsView.js